import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const reportsModule = {
  namespaced: true,
  state() {
    return {
      excludedItems: [],
      enableExcludeItems: false,
      reportType: 'internal',
      reportView: {},
      galleryImages: [],
      gallaryStartIndex: 0,
      selectedPhaseId: null,
    };
  },
  actions,
  mutations,
  getters,
};

export default reportsModule;
